/**
 * PostHog feature-flag keys (project "Menta Mentor"). Flags target platforms through the
 * `platform` group the auth provider sets, so a flag is switched on per school in PostHog.
 */
export const FEATURE_FLAGS = {
  /** Live sessions (Эфиры) and the Zoom/Meet integrations they run on. */
  LIVE_SESSIONS: 'live-sessions',
  CHATBOT: 'chatbot',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
